export default "__VITE_ASSET__BOmvfsKQ__"